import { MarketplaceType } from "../dropTypes";

export const trim = (str: string) => str.replace(/^\s+|\s+$/g, "");

export const uid = () =>
  Date.now().toString(36) + Math.random().toString(36).substring(3);

export const upperCaseFirst = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const dropTypePrettifier = (type: string) =>
  `${
    type === "dmc/single"
      ? "Single"
      : type === "dmc/ep"
      ? "EP"
      : type === "dmc/album"
      ? "Album"
      : "Box Set"
  }`;

export const serialize = (params: { [key: string]: string | number }) => {
  var str = [];
  for (var p in params)
    if (params.hasOwnProperty(p))
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
  return str.join("&");
};

export const marketActivityPrettifier = (
  type: MarketplaceType,
  isSeller?: boolean
) => {
  if (isSeller && type === "PRIMARY_SALE") {
    return "Sell (Primary)";
  }
  if (isSeller && type === "SECONDARY_SALE") {
    return "Sell (Secondary)";
  }

  switch (type) {
    case "LISTING":
      return "Listing";
    case "UPDATE_LISTING":
      return "Reprice";
    case "DELISTING":
      return "Delisting";
    case "PRIMARY_SALE":
      return "Buy (Primary)";
    case "SECONDARY_SALE":
      return "Buy (Secondary)";
    default:
      return "";
  }
};
